import { IListItem } from "../../classes/list-item";
import { IAppAction } from "../../classes/action";
import { ActionType } from "../actions/actiontype";
import { Action } from "redux";
import * as moment from 'moment';
export interface IFilterState {
    filters: { [property: string]: string };
    filterOptions: { [property: string]: string[] };
    currentMonth: moment.Moment;
    monthWithEvent: moment.Moment[];
    updating: boolean;
    error: any;
    everyXWeek: any[],
    nthDayOfMonth: any[],
    hideSpecialtiesFilter: boolean,
    hideZipOrCityFilter: boolean,
    hideGenderFilter: boolean,
    hideLanguageFilter: boolean,
    hideProviderDesignationFilter: boolean,
    hideHospitalPracticeFilter: boolean,
    hideNetworkFilter: boolean,
    hideCityFilter:boolean,
    showPrintButton: boolean,
    searchWithinTitle:string,
}

export const defaultFilterState: IFilterState = {
    filters: {},
    filterOptions: {},
    updating: false,
    currentMonth: moment(),
    monthWithEvent: [],
    error: null,
    everyXWeek: [],
    nthDayOfMonth: [],
    hideSpecialtiesFilter: false,
    hideZipOrCityFilter: false,
    hideGenderFilter: false,
    hideLanguageFilter: false,
    hideProviderDesignationFilter: false,
    hideHospitalPracticeFilter: false,
    hideNetworkFilter: false,
    showPrintButton: false,
    hideCityFilter: false,
    searchWithinTitle : "Search Within"
};
const persistSelectedFilters = (selectedFilter: string, currFilters: any, newFilters: any, filterName: string) => {
    if (selectedFilter) {
        selectedFilter.split('|').map(filter => {
            if (Object.keys(newFilters[filterName]).indexOf(selectedFilter) === -1) {
                newFilters[filterName][filter] = currFilters[filterName][filter]
            }
        })
    }
}

export function filterReducer(state = defaultFilterState, action: IAppAction): IFilterState {
    switch (action.type) {
        case ActionType.UPSERT_FILTER: {
            const filterProperty: string = action.value.property;
            const filterValue: string = action.value.value;

            const updatedFilters = { ...state.filters, [filterProperty]: filterValue };
            if (filterProperty !== 'page') {
                updatedFilters['page'] = '1'
            }
            return { ...state, filters: updatedFilters };
        }
        case ActionType.UPDATE_FILTERS: {
            const currFilters = state.filterOptions
            const currSelectedFilters = state.filters
            const selectedHospital = currSelectedFilters.hospital;
            const selectedPractice = currSelectedFilters.practice;
            const newFilters: any = action.value ? action.value : {}

            // leave filter if selected but not returned
            persistSelectedFilters(selectedHospital, currFilters, newFilters, 'hospital');
            persistSelectedFilters(selectedPractice, currFilters, newFilters, 'practice');

            const updatedFilters = { ...currFilters, ...newFilters }
            return { ...state, filterOptions: updatedFilters }
        }
        case ActionType.NEXT_MONTH: {
            const next = state.currentMonth.clone().add(1, 'month')
            return { ...state, currentMonth: next };
        }
        case ActionType.PREV_MONTH: {
            const prev = state.currentMonth.clone().subtract(1, 'month')
            return { ...state, currentMonth: prev };
        }

        case ActionType.REMOVE_FILTER: {
            const filterProperty: string = action.value;

            let filters = { ...state.filters };
            delete filters[filterProperty];

            return { ...state, filters: filters };
        }

        case ActionType.REMOVE_ALL_FILTERS: {

            let oldFilters = { ...state.filters };

            let newFilters = {};

            const LOCATION_PARENT = "LocationParent";

            if (oldFilters[LOCATION_PARENT] != null)
                newFilters[LOCATION_PARENT] = oldFilters[LOCATION_PARENT];

            return { ...state, filters: newFilters, currentMonth: moment() };
        }

        case ActionType.STORE_EVENTS: {
            return { ...state, updating: false, monthWithEvent: action.value.response, everyXWeek: action.value.everyXWeek, nthDayOfMonth: action.value.nthDayOfMonth }
        }
        case ActionType.REQUEST_EVENTS: {
            return { ...state, updating: true };
        }

        case ActionType.STORE_FILTER_OPTIONS: {
            return { ...state, updating: false, filterOptions: action.value };
        }

        case ActionType.ERROR_FILTER_OPTIONS: {
            return { ...state, updating: false, error: action.value };
        }

        case ActionType.SET_SPECIALTIES_FILTER: {
            return { ...state, hideSpecialtiesFilter: action.value}
        }

        case ActionType.SET_ZIP_OR_CITY_FILTER: {
            return { ...state, hideZipOrCityFilter: action.value }
        }

        case ActionType.SET_GENDER_FILTER: {
            return { ...state, hideGenderFilter: action.value }
        }

        case ActionType.SET_LANGUAGE_FILTER: {
            return { ...state, hideLanguageFilter: action.value }
        }

        case ActionType.SET_PROVIDER_DESIGNATION_FILTER: {
            return { ...state, hideProviderDesignationFilter: action.value }
        }

        case ActionType.SET_HOSPITAL_PRACTICE_FILTER: {
            return { ...state, hideHospitalPracticeFilter: action.value }
        }

        case ActionType.SET_NETWORK_FILTER: {
            return { ...state, hideNetworkFilter: action.value }
        }

        case ActionType.SET_PRINT_BUTTON: {
            return { ...state, showPrintButton: action.value }
        }
        case ActionType.SET_CITY_FILTER: {
            return { ...state, hideCityFilter: action.value }
        }
        case ActionType.SET_SEARCHWITHIN_TITLE: {
            return { ...state, searchWithinTitle: action.value }
        }

        default: {
            return state;
        }
    }
}